import { createFileRoute, notFound } from "@tanstack/react-router";

import { devicesQueries } from "@/api/resources/devices/queries";
import { maintenanceItemsQueries } from "@/api/resources/maintenanceItems/queries";
import { maintenancesQueries } from "@/api/resources/maintenances/queries";
import { maintenancesToDevicesQueries } from "@/api/resources/maintenancesToDevices/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import MaintenanceDevicePage from "@/components/MaintenanceDevice/MaintenanceDevicePage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute(
  "/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/",
)({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.maintenances"),
        icon: <Icon.MAINTENANCES />,
        path: "/workspaces/$workspace_id/maintenances",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, maintenance_id, device_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentMaintenance = await context.queryClient.ensureQueryData(maintenancesQueries.byId(maintenance_id));
    if (!currentMaintenance) throw notFound();
    const currentDevice = await context.queryClient.ensureQueryData(devicesQueries.byId(device_id));
    if (!currentDevice) throw notFound();

    await Promise.all([
      context.queryClient.ensureQueryData(maintenancesToDevicesQueries.byMaintenance(currentMaintenance.id)),
      context.queryClient.ensureQueryData(maintenanceItemsQueries.listById(currentMaintenance.id)),
    ]);

    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: currentMaintenance.title,
        icon: <Icon.MAINTENANCE />,
        path: "/workspaces/$workspace_id/maintenances/$maintenance_id",
      },
      {
        label: currentDevice.name,
        icon: <Icon.DEVICE />,
      },
    ];
    context.breadcrumbs.splice(2, 2, ...breadcrumbs);
  },
  component: MaintenanceDevicePage,
});
